<template>
    <li v-if="data.children && data.children.length == 0" class="nav-item" :class="class">
        <!-- <a :href="data.link" :target="data.target" class="nav-link">{{data.translate.name}}</a> -->
        <router-link
            v-if="data.type == 'content'"
            :to="{name: 'menu_detail', params: {id: data.id, lang: def_lang} }"
            :target="data.target"
            class="nav-link px-3 text-site"
            >
            <!-- v-html="data.translate[0].name" -->
            <img v-if="data.image" :src="data.image" style="width: 24px; height: 24px; border-radius: 50%;" />
            {{ data.translate[0].name }}
        </router-link>
        <router-link
            v-else-if="data.link && !data.link.match(/^#/i) && !data.link.match(/^http/i)"
            :to="{name: data.link, params: data.link_param ? Object.assign({lang: def_lang}, data.link_param) : {lang: def_lang} }"
            :target="data.target"
            class="nav-link px-3 text-site"
            >
            <!-- v-html="data.translate[0].name" -->
            <img v-if="data.image" :src="data.image" style="width: 24px; height: 24px; border-radius: 50%;" />
            {{ data.translate[0].name }}
        </router-link>
        <a v-else="" :href="data.link"
            :target="data.target"
            class="nav-link px-3 text-site"
            >
            <!-- v-html="data.translate[0].name" -->
            <img v-if="data.image" :src="data.image" style="width: 24px; height: 24px; border-radius: 50%;" />
            {{ data.translate[0].name }}
        </a>
    </li>
    <li v-if="data.children && data.children.length > 0" class="nav-item dropdown" :class="class">
            <!-- :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light1`" -->
        <!-- <a
            class="nav-link dropdown-toggle1"
            :href="data.link"
            :target="data.target"
            data-bs-toggle="dropdown"
          .fa  aria-expanded="fals "
        >
            {{ data.translate.name }}
        </a> -->
        <a
            v-if="data.type == 'link' && data.children && data.children.length > 0"
            class="nav-link px-3 text-site cursor-pointer"
            aria-expanded="false"
            data-bs-toggle="dropdown"
            >
            <!-- v-html="data.translate[0].name" -->
            <img v-if="data.image" :src="data.image" style="width: 24px; height: 24px; border-radius: 50%;" />
            {{ data.translate[0].name }}
        </a>
        <router-link
            v-else-if="data.link && !data.link.match(/^#/i) && !data.link.match(/^http/i)"
            :to="{name: data.link, params: data.link_param ? Object.assign({lang: def_lang}, data.link_param) : {lang: def_lang} }"

            class="nav-link px-3 text-site"
            :target="data.target"
            aria-expanded="false"
            >
            <!-- v-html="data.translate[0].name" -->
            <img v-if="data.image" :src="data.image" style="width: 24px; height: 24px; border-radius: 50%;" />
            {{ data.translate[0].name }}
        </router-link>
        <template v-else>
             <a
                :href="data.link"
                class="nav-link px-3 text-site"
                :target="data.target"
                aria-expanded="false"
                data-bs-toggle="dropdown"
                v-html="data.translate[0].name"
                >
            </a>
            <!-- <img v-if="data.image" :src="data.image" style="width: 24px; height: 24px; border-radius: 50%;" />
            {{ data.translate[0].name }} -->
        </template>
        <ul class="dropdown-menu" v-if="data.children && data.children.length">
            <MenuItem v-for="child in data.children"
                :key="child.id"
                :data="child" />
        </ul>
    </li>
</template>


<script>
// import { useRoute } from "vue-router";
import { useStore } from "@/system_modules/store";

import MenuItem from '@/components/navbar/MenuItem';

export default {
    name: "MenuItemC",
    components:{
        MenuItem,
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        class: {
            type: String,
            default: () => ''
        }
    },
    setup() {
        const store = useStore();
        // const route = useRoute();

        // const def_lang = route.params && route.params.lang !== undefined ? route.params.lang : "az";
        const def_lang = store.getLang();

        return {def_lang};
    },
}
</script>


<style scoped>
.nav-link{
    font-weight: 600;
}
.dropdown a{
    word-break: break-all !important;
}
.dropdown:hover > a{
    background-color: rgb(var(--site-primary-color-rgb));
    color: #ffffff;
    border-radius: .5rem;
}
.dropdown:hover > .nav-link{
    border-radius: .5rem;
    border-end-start-radius: 0;
    border-end-end-radius: 0;
}

@media(min-width: 820px){
    .nav-link:hover, .dropdown:hover>a{
        background-color: rgb(var(--site-primary-color-rgb));
        color: #ffffff !important;
        border-radius: .5rem;
    }
    .dropdown-menu{
        margin-top: 0px;
    }
    .dropdown-menu>.dropdown:hover>a{
        background-color: rgb(var(--site-primary-color-rgb));
        color: #ffffff;
    }
    .dropdown>.dropdown-menu{
        display: none;
        padding: 5px;
        /* border-radius: .5rem; */
        width: 280px;
    }

    .dropdown:hover>.dropdown-menu{
        display: block;
        border-start-start-radius: 0;
        border-start-end-radius: .5rem;
    }
    .navbar-nav>.dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        margin-left: 5px;
    }
    .dropdown-menu>.dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        position: absolute;
        top: 20%;
        right: 10px;
        left: auto;
    }
    .dropdown-menu>.dropdown:hover>a::after{
        transform: rotate(-90deg);
    }

    .dropdown-menu>.dropdown:hover>.dropdown-menu{
        display: block;
        top: -5px;
        margin-left: 270px;
    }

    /* .dropdown-menu > .dropdown:hover > a {
        border-radius: 5px;
    }
    .dropdown > .dropdown-menu {
        border-radius: 5px;
    }
    .nav-link:hover, .dropdown:hover > a {
        border-radius: 5px;
    } */
}
@media(max-width: 820px){
    .dropdown>.dropdown-menu{
        padding: 5px;
    }
    .dropdown>.dropdown-menu.show{
        display: block;
    }
    .dropdown-menu.show .dropdown-menu{
        display: block;
        margin-left: 25px;
    }
    .navbar-nav>.dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        margin-left: 5px;
    }
    .dropdown-menu.show .dropdown>a::after{
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f0d7";
        position: absolute;
        /* top: 20%; */
        right: 10px;
        left: auto;
    }
}
</style>
